import { render, staticRenderFns } from "./Hand.vue?vue&type=template&id=f936a0d2&"
import script from "./Hand.vue?vue&type=script&lang=js&"
export * from "./Hand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports